import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useSelectedStore from "../../../hooks/useSelectedStore";
import useStoreStatus from "../../../hooks/useStoreStatus";
import { useVisibility } from "../../../hooks/useVisibility";
import useMinimumOrderFees from "../../../hooks/useMinimumOrderFees";
import StarIcon from "../StarIcon";
import FullWidthStoreDescription from "../FullWidthStoreDescription";
import DeliveryToggle from "../DeliveryToggle";
import ParseFloat from "../../../utils/ParseFloat";
// import AvailableDays from "../../utils/ScheduleTimeDate/AvailableDays";
// import TabSelectionMenu from "./TabSelectionMenu";
// import useMinimumOrderFees from "../../hooks/useMinimumOrderFees";
// import useStoreStatus from "../../hooks/useStoreStatus";
// import Konsole from "../../utils/konsole/Konsole";
// import ParseFloat from "../../utils/ParseFloat";
// import StoreMainDescription from "../Description/StoreMainDescription";
// import DeliveryToggle from "./DeliveryToggle";
// import { useVisibility } from "../../hooks/useVisibility";
// import useSelectedStore from "../../hooks/useSelectedStore";
// import FullWidthStoreDescription from "./FullWidthStoreDescription";
// import StarIcon from "./StarIcon";

export default function KitchenCard({ className }: { className: string }) {
  const { t } = useTranslation();
  const { rating } = useSelectedStore()
  const { returnIsStoreClose, preOrder } = useStoreStatus();
  const [elementRef, isVisible] = useVisibility()

  const { returnStoreRadiousMinimumFees } = useMinimumOrderFees();
  const {
    store: { selectedStore, selectedType },
  }: any = useSelector((state: any) => state);
  const navigate = useNavigate();

  // @@ store open close status
  const returnStoreStatus = (className: string) => {
    return (
      <>
        <div className={`flex items-center hide-open-web ${className}`}>
          <button
            type="button"
            className={`${returnIsStoreClose
              ? "bg-[#FF0000] text-white"
              : "bg-[#F3F3F3] text-black"
              }md:px-10 px-6 py-2 cursor-text rounded-md textMd font-medium whitespace-nowrap`}
          >
            {preOrder
              ? t("MyOrders.preOrder")
              : returnIsStoreClose
                ? t("Home.closed")
                : t("Home.open")}
          </button>
        </div>
      </>
    );
  };

  // console.log("selectedStore", selectedStore)

  // const classNameHeight = useMemo(() => {
  //   return rating.isRating ? 'min-order-height-with-rating' : 'min-order-height'
  // }, [rating])
  // height is content-driven so stores without a description don't leave empty space
  // border border-gray-200 shadow-sm rounded-2xl
 return (
  <div className="

    bg-white overflow-hidden mb-4">

    <div className={`md:pt-4 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">

        {/* LEFT SIDE */}
        <div className="flex-1">
          <h4
            className="text-xl sm:text-2xl font-bold mt-1 custom-heading-store"
            ref={elementRef}
          >
            {selectedStore?.store_name || ""}
          </h4>

          {rating.rating > 0 ? (
            <div
              className="flex gap-1 cursor-pointer md:mb-3 leading-none"
              onClick={() => navigate("/review")}
            >
              <span className="custom-heding-style-2">
                {selectedStore?.rating?.toFixed(1)}
              </span>

              <StarIcon size="16" />

              <span className="custom-heding-style-2">
                ({selectedStore?.rating_count || 0})
              </span>
            </div>
          ) : (
            <div className="md:mb-3"></div>
          )}

          {selectedStore?.description && (
            <FullWidthStoreDescription
              text={selectedStore.description}
              store={selectedStore}
            />
          )}
        </div>

        {/* RIGHT SIDE */}
        <div className="flex flex-col items-center sm:items-end text-center sm:min-w-[220px]">
          <div>
            <DeliveryToggle
              onSelectionChange={(value) => console.log(value)}
              defaultValue="delivery"
            />

            {selectedType == 3 &&
              returnStoreRadiousMinimumFees > 0 && (
                <div className="w-full text-[11px] leading-none text-gray-500 mt-1 text-center">
                  Minimum order fee {ParseFloat(returnStoreRadiousMinimumFees)}
                </div>
              )}
          </div>
        </div>

      </div>
    </div>

  </div>
);
}
